import AppWrapper from 'AppWrapper';
import { apiClient } from 'api';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';

import { ChainlitContext } from '@chainlit/react-client';

import './index.css';

import { i18nSetupLocalization } from './i18n';
const message = { action: "getAiThemeData" };

window.parent.postMessage(message, "https://app.webdock.io");
window.parent.postMessage(message, "https://webdock.io");
window.parent.postMessage(message, "https://staging.webdock.io");

const handleMessage = (event: any) => {

  if (event.data.action === "setAIThemeData") {
    localStorage.setItem("AIQuestionSetId", event.data.AIQuestionSetId);
  }
}
window.addEventListener("message", handleMessage);

i18nSetupLocalization();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ChainlitContext.Provider value={apiClient}>
      <RecoilRoot>
        <AppWrapper />
      </RecoilRoot>
    </ChainlitContext.Provider>
  </React.StrictMode>
);
